import type { CalendarStateFilterType } from '$src/types/events';

export const CalendarStateFilter = $state<CalendarStateFilterType>({
  tags: [''],
  search: '',
  locationDisplay: '',
  locationCoordinates: [],
  distance: '',
  dateObjects: [],
});
